import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

/** Founder = the single admin account. */
export const FOUNDER_ID = "7e077286-2ba5-4884-a17b-62414a481108";

/** Set of user ids holding the coach role (readable by any signed-in member). */
export function useCoaches() {
  return useQuery({
    queryKey: ["coach-ids"],
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data } = await (supabase as any).rpc("list_coaches");
      return new Set<string>(((data ?? []) as any[]).map((r) => (typeof r === "string" ? r : r.list_coaches)));
    },
  });
}

export function useIsCoach() {
  const { user } = useAuth();
  const { data } = useCoaches();
  return !!user && !!data?.has(user.id);
}
